// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/calc/calc.scss';

// Packages
import Vue from 'vue';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';
import EconomyCalculator from '~scripts/components/EconomyCalculator/EconomyCalculator.vue';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

const defaultCalcParams = {
  amount: 1,
  salary: 50000,
  params: {
    resume_per_day: 24,
    mail_per_day: 6,
    cal_per_day: 5,
    mail_tpl_per_day: 11,
  },
};

const localCalcParams = JSON.parse(localStorage.getItem('params'));

new Vue({
  el: '#vueapp',
  name: 'VApp',
  components: {
    EconomyCalculator,
  },
  data: {
    defaultCalcParams,
    calcParams: localCalcParams || defaultCalcParams,
  },
});

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
